import { createFileRoute } from '@tanstack/react-router'
import { CalendarPage } from '@/features/scheduler'
import { parseCalendarSearch } from '@/features/scheduler/utils/calendar-search'

/**
 * Calendar view state lives in the URL (spec R4). `parseCalendarSearch` declares every
 * key explicitly and returns no index signature — see calendar-search.ts for why.
 */
export const Route = createFileRoute(
  '/_authenticated/_organization/scheduler/'
)({
  validateSearch: parseCalendarSearch,
  component: CalendarPage,
})
